import * as React from 'react';
import Modal from '@westwing/ui-kit/Modal';
import ActionButton from '@westwing/ui-kit/ActionButton';
import * as Styled from './OverwhelmedForm.styles';
import useOverwhelmedForm from './useOverwhelmedForm';
import { useOverwhelmedOverlayDispatch, useOverwhelmedOverlayState } from '@ids/context/OverwhelmedOverlay';
import useIdsGaTracking from '@ids/hooks/useIdsGaTracking';

export const USER_SUBMITTED_OVERWHELMED_FORM = 'user_submitted_overwhelmed_form';

const EmailForm = () => {
    const { showThankYouNote, hideOverwhelmedOverlay } = useOverwhelmedOverlayDispatch();
    const { formData } = useOverwhelmedOverlayState();
    const { formRef, handleSubmit } = useOverwhelmedForm(() => {
        showThankYouNote();
        setTimeout(() => hideOverwhelmedOverlay(), (formData?.thankYouNote.timer ?? 3) * 1000);
    });

    return (
        <Styled.Form ref={formRef} onSubmit={handleSubmit} data-testid="overwhelmed-form">
            <Styled.FormTitle variant="subtitle">{formData?.emailForm.title}</Styled.FormTitle>
            <Styled.FormDescription>{formData?.emailForm.description}</Styled.FormDescription>
            <Styled.FormQuestion>{formData?.emailForm.question}</Styled.FormQuestion>
            <Styled.Fieldset>
                <Styled.Label htmlFor="email">Email</Styled.Label>
                <Styled.EmailInput
                    data-autofocus
                    id="email"
                    name="email"
                    type="email"
                    required
                    placeholder={formData?.emailForm.inputPlaceholder}
                />
            </Styled.Fieldset>
            <ActionButton as="input" kind="primary" type="submit" value={formData?.emailForm.ctaText} />
        </Styled.Form>
    );
};

const ThankYouNote = () => {
    const { formData } = useOverwhelmedOverlayState();

    return (
        <Styled.ThankYouNote data-testid="overwhelmed-thank-you-note">
            <Styled.FormTitle>{formData?.thankYouNote.title}</Styled.FormTitle>
            <Styled.FormDescription>{formData?.thankYouNote.description}</Styled.FormDescription>
        </Styled.ThankYouNote>
    );
};

const OverwhelmedForm = () => {
    const { formData, isThankYouNoteOpen, isOverwhelmedOverlayOpen } = useOverwhelmedOverlayState();
    const { hideOverwhelmedOverlay, showOverwhelmedOverlay } = useOverwhelmedOverlayDispatch();
    const { trackIdsEvent } = useIdsGaTracking();

    if (!formData) {
        return null;
    }

    const onClose = () => {
        trackIdsEvent({
            action: 'Content interaction click',
            label: isThankYouNoteOpen ? 'Dismiss overlay thanks' : 'Dismiss overlay w/o email',
        });

        hideOverwhelmedOverlay();
    };

    return (
        <Modal
            onClose={onClose}
            isOpen={isOverwhelmedOverlayOpen}
            onOpen={showOverwhelmedOverlay}
            data-testid="overwhelmed-overlay"
        >
            <Styled.OverwhelmedForm>
                <Modal.CloseButton data-testid="overwhelmed-form-dismiss-button" />
                {isThankYouNoteOpen ? <ThankYouNote /> : <EmailForm />}
            </Styled.OverwhelmedForm>
        </Modal>
    );
};

export default OverwhelmedForm;
